import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import Typography from '../typography';

interface TagProps {
  className?: string;
}

const Tag: FunctionComponent<TagProps> = ({ className, children }) => {
  return (
    <div className={className || ''}>
      <Typography className="tag-text" type="small" weight="700">
        {children}
      </Typography>
    </div>
  );
};

export default styled(Tag)`
  background-color: ${({ theme }) => theme.colors.primary};
  border-radius: 90px;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  .tag-text {
    color: ${({ theme }) => theme.colors.differentBackground};
  }
`;
